import axios from "axios";
import {
  filterDemoProducts,
  getDemoCategories,
  getDemoProduct,
} from "@/lib/demoData";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const IS_DEMO = !BACKEND_URL;
export const API = BACKEND_URL ? `${BACKEND_URL}/api` : "/api";

function demoResponse(data, status = 200) {
  return Promise.resolve({
    data,
    status,
    statusText: status === 200 ? "OK" : "Error",
    headers: {},
    config: {},
  });
}

function demoError(message, status = 404) {
  const err = new Error(message);
  err.response = { data: { detail: message }, status };
  return Promise.reject(err);
}

function handleDemoRequest(config) {
  const method = (config.method || "get").toLowerCase();
  const url = (config.url || "").replace(/^\/+/, "");
  const params = config.params || {};
  let body = config.data;
  if (typeof body === "string") {
    try { body = JSON.parse(body); } catch { body = {}; }
  }
  body = body || {};

  if (method === "get" && url === "auth/me") {
    return demoError("Não autenticado", 401);
  }

  if (method === "get" && url === "products") {
    return demoResponse(filterDemoProducts(params));
  }

  if (method === "get" && url === "categories") {
    return demoResponse(getDemoCategories());
  }

  const productMatch = url.match(/^products\/(.+)$/);
  if (method === "get" && productMatch) {
    const product = getDemoProduct(productMatch[1]);
    if (!product) return demoError("Produto não encontrado", 404);
    return demoResponse(product);
  }

  if (method === "post" && url === "shipping/calc") {
    const subtotal = Number(body.subtotal || 0);
    const free = subtotal >= 499;
    return demoResponse({
      options: [
        { method: "PAC", label: "Entrega Econômica (PAC)", price: free ? 0 : 29.9, days: 8, free },
        { method: "SEDEX", label: "Entrega Expressa (SEDEX)", price: 49.9, days: 3, free: false },
      ],
    });
  }

  if (method === "post" && url === "coupons/validate") {
    return demoError("Cupom inválido (demo)", 400);
  }

  if (method === "post" && url === "checkout") {
    return demoError("Checkout indisponível nesta demonstração", 501);
  }

  if (method === "post" && (url === "auth/login" || url === "auth/register")) {
    return demoError("Autenticação indisponível nesta demonstração", 501);
  }

  return demoError("Endpoint indisponível nesta demonstração", 501);
}

const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

if (IS_DEMO) {
  api.defaults.adapter = (config) => handleDemoRequest(config);
}

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Algo deu errado. Tente novamente.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).filter(Boolean).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export const formatBRL = (value) =>
  new Intl.NumberFormat("pt-BR", { style: "currency", currency: "BRL" }).format(value || 0);

export default api;
